import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";
import CustomDatePicker from "./CustomDatePicker";

const DatePickerComponent = ({
  myName,
  formComponentData,
  getValue,
  setValue,
  parentHandleSave,  
  parentSetValue,   
}) => {
  const [date, setDate] = useState("");

  useEffect(() => {
    const source = parentSetValue ?? getValue(myName);

    if (source && source.dateObject) {
      const parsed = new Date(source.dateObject);
      if (!isNaN(parsed)) {
        setDate(parsed);
        return;
      }
    }

    if (myName === "reportDetails.reportDate") {
      setDate(new Date());
    } else {
      setDate("");
    }
  }, [myName, getValue, parentSetValue]);

  const handleChange = (picked) => {
    if (picked) {
      const y = picked.getFullYear();
      const m = ('0' + (picked.getMonth() + 1)).slice(-2);
      const day = ('0' + picked.getDate()).slice(-2);
      const payload = {
        date: `${y}/${m}/${day}`,
        dateObject: picked,
      };

      if (typeof parentHandleSave === "function") {
        parentHandleSave(payload, myName); 
      } else {
        setValue(payload, myName);        
      }
      setDate(picked);
    } else {
      if (typeof parentHandleSave === "function") {
        parentHandleSave("", myName);
      } else {
        setValue("", myName);
      }
      setDate("");
    }
  };

  return (
    <div>
      {formComponentData.description && (
        <label
          htmlFor={formComponentData.name}
          className={classnames(
            "input-shell__label",
            "input-shell__label--dark",
            { "input-shell__label--required": formComponentData.required }
          )}
        >
          {formComponentData.description}
        </label>
      )}

      <CustomDatePicker
        selected={date}
        onChange={handleChange}
        placeholderText={formComponentData.placeholder}
        minDate={formComponentData.minDate}
        disabled={formComponentData.isDisabled}
      />

      {formComponentData.required && (
        <div className="input-shell__message">
          <div className="input-shell__message-hint">
            <FormattedMessage id="formComponents.required" />
          </div>
        </div>
      )}
    </div>
  );
};

export default DatePickerComponent;